class InvoiceFields extends HTMLElement {
  constructor() {
    super();

    this.toggle = this.querySelector('[data-invoice-toggle]');
    this.editBtn = this.querySelector('[data-invoice-edit]');
    this.debouncedSave = FoxTheme.utils.debounce(this.onFieldChange.bind(this), 400);
  }

  get modal() {
    return document.getElementById(this.dataset.modalId);
  }

  get fields() {
    return this.modal ? Array.from(this.modal.querySelectorAll('[data-invoice-inputs] input')) : [];
  }

  connectedCallback() {
    if (this.toggle) {
      this.toggle.addEventListener('change', this.onToggle.bind(this));
    }

    // Modal alanlari ayri bir DOM dugumunde oldugu icin event delegation kullaniyoruz.
    this._onDocChange = (event) => {
      const modal = this.modal;
      if (modal && modal.contains(event.target) && event.target.matches('[data-invoice-inputs] input')) {
        this.debouncedSave();
      }
    };
    document.addEventListener('change', this._onDocChange);
  }

  disconnectedCallback() {
    if (this._onDocChange) {
      document.removeEventListener('change', this._onDocChange);
    }
  }

  onToggle(event) {
    const modal = this.modal;

    if (event.target.checked) {
      if (this.editBtn) this.editBtn.classList.remove('hidden');
      this.updateCart({ 'Kurumsal Fatura': 'Evet' });
      if (modal && typeof modal.show === 'function') modal.show();
    } else {
      if (this.editBtn) this.editBtn.classList.add('hidden');
      const attributes = { 'Kurumsal Fatura': '' };
      this.fields.forEach((field) => {
        field.value = '';
        attributes[this.attributeKey(field)] = '';
      });
      this.updateCart(attributes);
      if (modal && typeof modal.hide === 'function') modal.hide();
    }
  }

  onFieldChange() {
    const attributes = { 'Kurumsal Fatura': 'Evet' };
    this.fields.forEach((field) => {
      attributes[this.attributeKey(field)] = field.value.trim();
    });
    this.updateCart(attributes);
  }

  attributeKey(field) {
    return field
      .getAttribute('name')
      .replace(/^attributes\[/, '')
      .replace(/\]$/, '');
  }

  updateCart(attributes) {
    const body = JSON.stringify({ attributes });
    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } }).catch((error) => {
      console.error('[invoice-fields] cart update failed', error);
    });
  }
}
customElements.define('invoice-fields', InvoiceFields);
